import { useMutation } from "@tanstack/react-query";
import { ICreateStaffModel, IUpdateStaffModel } from "../../models/Staff";
import { StaffService } from "../../services/staff.service";

export const useStaffMutations = () => {
  const { mutate: createAdmin } = useMutation<any, Error, ICreateStaffModel>({
    mutationFn: async (model) => StaffService.createAdmin(model),
  });

  const { mutate: updateAdmin } = useMutation<any, Error, { id: string; model: IUpdateStaffModel }>(
    {
      mutationFn: async ({ id, model }) => StaffService.updateAdmin(id, model),
    }
  );

  const { mutate: deleteAdmin } = useMutation<any, Error, string>({
    mutationFn: async (id) => StaffService.deleteAdmin(id),
  });

  const { mutate: createSupport } = useMutation<any, Error, ICreateStaffModel>({
    mutationFn: async (model) => StaffService.createSupport(model),
  });

  const { mutate: updateSupport } = useMutation<
    any,
    Error,
    { id: string; model: IUpdateStaffModel }
  >({
    mutationFn: async ({ id, model }) => StaffService.updateSupport(id, model),
  });

  const { mutate: deleteSupport } = useMutation<any, Error, string>({
    mutationFn: async (id) => StaffService.deleteSupport(id),
  });

  return {
    createAdmin,
    updateAdmin,
    deleteAdmin,
    createSupport,
    updateSupport,
    deleteSupport,
  };
};
